<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Country Code"
                  v-model="country.code"
                  type="text"
                  :rules="rules.lengthRequiredRules(20, 'Country code')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Country Name"
                  v-model="country.name"
                  type="text"
                  :rules="rules.lengthRequiredRules(100, 'Country name')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="country.description"
                  type="text"
                  :rules="rules.lengthRules(500, 'Description')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="country.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="country.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="country.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="country.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="country.id">
                <v-text-field
                  name="updatedBy"
                  label="Updated By"
                  v-model="country.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="country.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
  
<script>
import { CountryFormRules } from "../../helpers/validation-rules";
import { Country } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { countryService } from "../../services/country-service";
import { commonService } from "../../services/common-service";

export default {
  name: "CountryDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    saveLoading: false,
    statusFlag: true,
    breadcrumbs: [
      {
        text: "Country",
        disabled: false,
        to: "countrys",
      },
      {
        text: "Country Detail",
        disabled: true,
      },
    ],
    updatedDate: "",
    createdDate: "",
    responseError: "",
    rules: new CountryFormRules(),
    country: new Country(),
    oldCountry: new Country(),
  }),
  created() {
    const id = this.$route.params.id;
    if (id != "new") {
      this.getCountryDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.country.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        countryService
          .saveCountry(this.country)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getCountryDetail(id) {
      countryService
        .getCountryDetail(id)
        .then((res) => {
          this.country = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.country.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.country.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.oldCountry = Object.assign({}, res.data);
          this.statusFlag = this.country.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.country.id) {
        this.country = new Country();
        this.statusFlag = true;
      } else {
        this.country = Object.assign({}, this.oldCountry);
        this.statusFlag = this.country.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/countrys");
    },
  },
};
</script>